import { connect } from 'react-redux';
import { postDaoHo, setDaoHo } from 'actions/TraGop/DaoHo';
import ChiTietTongSoTienDaTra from 'components/CommonComponent/ChiTietSoTienDaTra/TT_SoTienDaTra';

const mapStateToProps = (state) => ({
  //data: state.data,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ChiTietTongSoTienDaTra);
